import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { QuestionSet } from '../models/questionSet.model';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-question-set-editor',
  templateUrl: './question-set-editor.page.html',
  styleUrls: ['./question-set-editor.page.scss'],
})
export class QuestionSetEditorPage implements OnInit {

  public questionSets: Observable<QuestionSet[]>;

  constructor(private router: Router, private dataService: DataService, public alertController: AlertController) {
  }

  async ngOnInit() {
    this.questionSets = this.dataService.getQuestionSets();
  }

  openQuestionEditorPage(selectedQuestionSetEdit: QuestionSet) {
    if (selectedQuestionSetEdit != null){
      this.dataService.setSelectedQuestionSet(selectedQuestionSetEdit);
    }
    else{
      this.dataService.setSelectedQuestionSet(null);
    }
    this.router.navigate(['/question-editor']);
  }

  deleteQuestionSet(questionSet: QuestionSet){
    if (this.isSetOwner(questionSet.owner)){
      this.presentAlertConfirm(questionSet);
    }
    else{
      this.presentAlertCantDelete();
    }
  }

  async presentAlertConfirm(questionSet: QuestionSet) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Are you sure?',
      message: 'Are you sure you would like to delete the selected question set? This can not be undone.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        }, {
          text: 'Yes',
          handler: async () => {
            this.dataService.deleteQuestionSet(questionSet);
          }
        }
      ]
    });

    await alert.present();
  }

  async presentAlertCantDelete() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      message: 'You are not the owner of this set. You can only delete sets that you create.',
      buttons: ['OK']
    });

    await alert.present();
  }

  isSetOwner(ownerUID: string){
    const user = JSON.parse(localStorage.getItem('user'));
    if (ownerUID === user.uid){
      return true;
    }
    return false;
  }
}
